import { parseTagsArray, tagsToDisplayString } from './recipeTagFilters';
import { normalizeIngredientList } from './ingredientNormalize';

/**
 * Preserve UUID recipe IDs in meal-plan slot payloads (legacy int strings still work).
 */
export function normalizeRecipeSlotId(value) {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value === 'object' && value !== null && value.id != null) {
    return String(value.id).trim();
  }
  const s = String(value).trim();
  return s || null;
}

export function normalizeRecipeFromApi(recipe) {
  if (!recipe) return null;

  const tags = parseTagsArray(recipe.tags);

  return {
    id: recipe.recipe_id || recipe.id || recipe._id,
    nombre: recipe.nombre || recipe.titulo || recipe.title || '',
    descripcion: recipe.descripcion || recipe.description || '',
    racion: recipe.racion ?? recipe.servings ?? 4,
    tags,
    tagsDisplay: tagsToDisplayString(tags),
    tipo_platillo: recipe.tipo_platillo || recipe.tipoPlatillo || recipe.category || '',
    fuente: recipe.fuente || recipe.source || '',
    ingredientes: normalizeIngredientList(recipe.ingredientes || recipe.ingredients),
    notas: recipe.notas ?? recipe.notes ?? '',
    isPublic: recipe.isPublic ?? recipe.is_public ?? true,
    isArchived: recipe.isArchived ?? recipe.is_archived ?? false,
    userId: recipe.userId || recipe.user_id || null,
    createdAt: recipe.createdAt || recipe.created_at || null,
    updatedAt: recipe.updatedAt || recipe.updated_at || null,
    plan: recipe.plan ?? null,
  };
}

export function normalizeRecipeListFromApi(payload) {
  const rows = Array.isArray(payload)
    ? payload
    : payload?.recipeResult || payload?.recipes || [];
  return rows.map(normalizeRecipeFromApi).filter(Boolean);
}
